export function currentSection() {
  const p = window.location.pathname;
  if (p === "/hub" || p.startsWith("/hub/")) return "hub";
  if (p === "/admin" || p.startsWith("/admin/")) return "fire-admin";
  return "fire-public";
}
